import { Box, Button, Divider, Text } from '@chakra-ui/react';
import { DownloadIcon } from '@udacity/chakra-uds-icons';

import { Card } from '~/components/card';
import { SanityImage } from '~/components/sanity-image';
import { trackEvent } from '~/features/analytics/track-event';
import { SanityImageType } from '~/features/page-template/models/image';

import { CaseStudyCompanyHighlight } from '../models/case-study-content';

export function CaseStudyCompanyCard({
  companyHighlights,
  companyLogo,
  industry,
  fileLink,
}: {
  companyHighlights: CaseStudyCompanyHighlight[];
  companyLogo: SanityImageType;
  industry: string;
  fileLink: string;
}) {
  return (
    <Card
      as='section'
      borderRadius={{ base: '0px 0px 4px 24px', md: '4px 4px 4px 24px' }}
      padding={{ base: '24px 16px 24px 16px', md: '40px 40px 40px 40px' }}
    >
      <SanityImage image={companyLogo} sizes='140px' style={{ width: '140px' }} />

      <Divider marginBottom='24px' marginTop='24px' />

      <Text>Industry</Text>
      <Text fontSize='28px' marginBottom='40px' marginTop='8px'>
        {industry}
      </Text>

      <Text marginBottom='16px'>How Udacity Helped</Text>

      {companyHighlights.map((companyHighlight) => (
        <Box key={companyHighlight.title} marginBottom='24px'>
          <Text color='accent.sea-foam.700' fontSize='20px'>
            {companyHighlight.title}
          </Text>
          <Text>{companyHighlight.text}</Text>
        </Box>
      ))}

      <Button
        as='a'
        colorScheme='blue'
        href={fileLink}
        rel='noopener noreferrer'
        rightIcon={<DownloadIcon h='24px' w='24px' />}
        size='icon-right'
        target='_blank'
        variant='outline'
        onClick={() =>
          trackEvent({
            type: 'click',
            name: 'Enterprise CTA Clicked',
            label: 'Enterprise Telenor Case Study Page CTA',
            action: 'download_pdf_clicked',
          })
        }
      >
        Download PDF
      </Button>
    </Card>
  );
}
